import { render, staticRenderFns } from "./GesSolicitud.vue?vue&type=template&id=2bce0f0e&scoped=true&"
import script from "./GesSolicitud.vue?vue&type=script&lang=js&"
export * from "./GesSolicitud.vue?vue&type=script&lang=js&"
import style0 from "./GesSolicitud.vue?vue&type=style&index=0&id=2bce0f0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce0f0e",
  null
  
)

export default component.exports